// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__NWPgq","counterSec":"Counter_counterSec__laQgJ","counterItems":"Counter_counterItems__uWcew"};